import { flushSync } from 'react-dom';

/** True when the person asked the OS for less motion: every JS animation collapses to an instant change. */
export const prefersReducedMotion = () => typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

type ViewTransitionDoc = Document & { startViewTransition?: (update: () => void) => { ready?: Promise<unknown>; finished?: Promise<unknown> } };

/**
 * Run a state change as a short crossfade of the page (the View Transitions API; durations in base.css): the old
 * picture fades into the new one. Instant where the browser has no view transitions or under reduced motion.
 * `update` must change React state; it is flushed synchronously inside the transition.
 */
export function crossfade(update: () => void) {
  const doc = typeof document === 'undefined' ? null : (document as ViewTransitionDoc);
  if (!doc?.startViewTransition || prefersReducedMotion() || doc.visibilityState !== 'visible') return update();
  const t = doc.startViewTransition(() => flushSync(update));
  // a transition skipped by the next one rejects these: nothing went wrong
  t.ready?.catch(() => undefined);
  t.finished?.catch(() => undefined);
}
